import React, { useContext, useEffect, useState } from "react";
import { Modal } from "antd";
import { ContextStore } from "../../../App";
import SolarCalculatorFunctionalities from "../../utills/SolarCalculatorFunctionalities";
import { DomainUrl } from "../../utills/CommonData";
import axios from "axios";
import { Link } from "react-router-dom";
import { SiteSurveyValidation } from "../../utills/Validation";

const SiteSurvey = ({ open, handleClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { setFormData, formData } = useContext(ContextStore);
  const { SiteSurveyInputs } = SolarCalculatorFunctionalities();
  const [errors, setErrors] = useState({});
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(false);
      setFormData({ firstName: "", lastName: "", email: "", phone: "" }); // Reset form
    }, 5000);
    return () => clearTimeout(timer);
  }, [isOpen]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = SiteSurveyValidation(formData);
    setErrors(validationErrors);
    console.log("Validation Errors:", validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      console.log("Form Data Submitted:", formData);

      try {
        console.log("Form Data Submitted:", formData);
        const response = await axios.post(
          `${DomainUrl}/siteSurveyForm`,
          formData,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        if (response.data.success) {
          setIsOpen(true);
          console.log("Form Data Submitted:", formData);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={handleClose}
      centered
      width={700}
    >
      {!isOpen ? (
        <div className="bg-white w-full rounded-xl p-8 flex flex-col gap-6 ">
          <div className="flex flex-col gap-3 text-center">
            <h1 className="text-error text-2xl font-bold">
              Schedule a Free Site Visit
            </h1>
            <p className="text-darkGray text-base">
              Discover how Janica Electronics can assist with your solar
              installation.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {SiteSurveyInputs.map((input) => {
                return (
                  <div key={input.id} className="flex flex-col gap-2 w-full">
                    <label className="text-darkGray text-sm" htmlFor="fName">
                      {input.label}
                    </label>
                    <input
                      id={input.name}
                      type={input.type}
                      className="p-3 rounded border border-neutral focus:ring-2 focus:ring-error focus:outline-none"
                      placeholder={input.placeholder}
                      name={input.name}
                      value={input.value}
                      onChange={handleInputChange}
                    />
                    {errors[input.name] && (
                      <p className="text-error text-sm">{errors[input.name]}</p>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Submit Button */}
            <button
              className="mt-4 bg-error rounded  w-36 mx-auto text-white py-2 px-2  text-lg font-semibold shadow-md hover:text-error hover:border hover:border-neutral hover:bg-white transition-all duration-300"
              type="submit"
            >
              Submit
            </button>
          </form>
        </div>
      ) : (
        <div className="bg-white p-6 rounded-2xl  mx-auto text-center max-w-md">
          <h2 className="text-2xl font-bold text-error text-center">
            Thank You! 🎉
          </h2>
          <p className="text-darkGray text-center mt-3">
            Your response has been submitted successfully. We appreciate your
            time and will get back to you soon.
          </p>
          <button className="mt-5 px-4 py-2 text-center bg-error  text-white rounded-lg  transition">
            <Link to="/">Back to Home</Link>
          </button>
        </div>
      )}
    </Modal>
  );
};

export default SiteSurvey;
